<template>
  <div class="qris">
    <div class="titleBox pc-width-pull-full">
      <!-- <i class="iconfont dm-arrow-left" @click="onBack" /> -->
      <h2 class="title">{{ $t('waiting.qrisTitle') }}</h2>
    </div>
    <div class="countDown">
      <span class="des">{{ $t('waiting.qrisPayWithin') }}</span>
      <span class="num">
        {{ toMinus(number / 1000) }}
      </span>
      <span class="unit">m</span>
      <span class="num">
        {{ toSeconds(number / 1000) }}
      </span>
      <span class="unit">s</span>
    </div>
    <div v-if="grandTotal" class="priceBox">
      <span class="pre">Rp</span>
      <span class="num">
        {{ $n(grandTotal, 'currency', 'id-ID').slice(2) }}
      </span>
    </div>
    <div class="qr text-center">
      <!-- <img class="qrCard" :src="qrCardBase64" /> -->
      <div id="QR_BOX" class="text-center qrBox">
        <div class="loading">
          <q-spinner v-if="imgloading" color="primary" size="3em" />
        </div>
        <div class="topText">{{ qrState.topText }}</div>
        <div class="logoText">Bakmi GM</div>
        <div class="id">{{ qrState.id }}</div>
        <template v-if="qrState.imgUrl && isIforteQris">
          <q-no-ssr>
            <vue-qr class="qrimage" :text="qrState.imgUrl" :size="245" :callback="onIforteQrReady" />
          </q-no-ssr>
        </template>
        <template v-if="qrState.imgUrl && payMethodTypeId === 'QBIZ_QRIS'">
          <q-no-ssr>
            <vue-qr class="qrimage" :text="qrState.imgUrl" />
          </q-no-ssr>
        </template>
        <template v-if="qrState.imgUrl && payMethodTypeId === 'XE_QRIS'">
          <q-no-ssr>
            <vue-qr class="qrimage" :text="qrState.imgUrl" />
          </q-no-ssr>
        </template>
        <template v-if="qrState.imgUrl && payMethodTypeId === 'MIDE_QRIS'">
          <img
            v-show="qrState.imgUrl"
            ref="qrRef"
            class="qrimage"
            :src="qrState.imgUrl"
            width="245px"
          />
        </template>
        <div class="leftBottom">{{ qrState.leftBottomText }}</div>
      </div>
      <b>*{{ $t('waiting.qrisQrTip') }}</b>
    </div>
    <div class="btnBox">
      <!-- <MButton :loading="downloading" class="downBtn" @click="downDoadQr">
        <i class="iconfont dm-a-download1" />
        <span>{{ $t('waiting.qrisDownloadBtnText') }}</span>
      </MButton> -->
      <MButton
        :loading="checking"
        :class="['checkBtn', { checking }]"
        @click="checkFn(true)"
      >
        <span>{{ $t('waiting.qrisCheckStatusText') }}</span>
      </MButton>
    </div>
    <transition name="fade">
      <div v-if="isShowGoDown" class="moreBtnBox">
        <div class="moreBtn" @click="scrollTo(9999)">
          <span>{{ $t('waiting.howToPayToBottom') }}</span>
          <i class="dm-arrow-left arrow iconfont" />
        </div>
      </div>
    </transition>

    <div class="howUseBox">
      <div class="howUseTitle">{{ $t('waiting.howPayQris') }}</div>
      <div class="stepBox">
        <div v-for="item in stepList" :key="item.id" class="item">
          <div class="stepTitleBox">
            <div class="numberIcon">{{ item.id }}</div>
            <span> {{ item.title }}</span>
          </div>
          <img :src="item.img" width="" />
        </div>
      </div>
    </div>
    <div class="payfrom">
      <h4>{{ $t('waiting.howToPayFrom') }}</h4>
      <div v-for="item in platformList" :key="item.id">
        <div class="payfromItem" @click="openDialogByType(item)">
          <div class="payfromItemLeftBox">
            <img :src="item.icon" width="24px" />
            <span>{{ item.id }}</span>
          </div>
          <i class="dm-right iconfont" :style="{ fontSize: '24px' }" />
        </div>
        <div class="blackSolid" />
      </div>
    </div>

    <div class="scrollTopBtnBox">
      <div class="scrollTopBtn" @click="scrollTo(0)">
        <span>{{ $t('waiting.howToPayToTop') }}</span>
        <i class="dm-arrow-left arrow top iconfont" />
      </div>
    </div>
    <q-dialog v-model="payTipDialog.show" maximized position="bottom">
      <div class="payDialog">
        <div class="dialogTitle">
          <div>{{ payTipDialog.currentItem.id }}</div>
          <i class="iconfont dm-close" @click="payTipDialog.show = false" />
        </div>
        <div class="stepBox">
          <div
            v-for="(item, i) in payTipDialog.currentItem.steps"
            :key="i"
            class="item"
          >
            <div class="stepTitleBox">
              <div class="numberIcon">{{ i + 1 }}</div>
              <span v-html="item.text" />
            </div>
            <img :src="$ossLimit(item.img, 150)" />
          </div>
        </div>
      </div>
    </q-dialog>
  </div>
</template>
<script setup>
import { useStore } from 'src/utils/v2_helper/common';
import { useRouter } from 'src/utils/v2_helper/router';
import { ref, onMounted, reactive, defineAsyncComponent, computed } from 'vue';
import { checkoutStatus, pullPaymentStatus } from 'src/api/order.js';
import MButton from 'src/components/MButton/index.vue';
import { useInterval } from 'src/utils/hooks/use-interval';
import {
  useCountDown,
  toMinus,
  toSeconds,
} from 'src/utils/hooks/use-countdown';
import { useLoading } from 'src/utils/hooks/loading';
import { useCloseDialog } from 'src/components/dialog';
import vueQr from 'vue-qr/src/packages/vue-qr.vue';
import { aboutSroll } from './aboutSroll';
import { useAboutPayTip } from './useAboutPayTip';
import { useAboutDownQR } from './useAboutDownQR';
import { useRoute } from '../../../utils/v2_helper/router';
import { PAY_STATUS, showPayFailedDialog } from '../config';
import { useIns } from '../../../utils/v2_helper/common';

useCloseDialog();
const router = useRouter();
const route = useRoute();
const store = useStore();
const app = useIns();
const { loading, hide } = useLoading();
const pid = ref();

// 滚动相关处理
const { isShowGoDown, scrollTo } = aboutSroll();
//  提示以及支付引导对话内容
const { stepList, platformList, openDialogByType, payTipDialog } =
  useAboutPayTip();
// downQr 相关内容
const { qrState, qrRef, imgloading } = useAboutDownQR();

const checking = ref(false);
const grandTotal = ref(0);
const checkFn = ref();

const orderId = computed(() => {
  const q = route.query;
  const id = (q.orderId || q.order_id)?.replace(/\d+_DM/, '');
  store.dispatch('Menu/setOrderId', id);
  return id;
});
const { number, set, start } = useCountDown(0);
const { pause, resume, isActive } = useInterval(checkFn, 2000);
const showTimeTip = ref(false);

const payMethodTypeId = ref();
const isIforteQris = ref(false);

function onIforteQrReady() {
  imgloading.value = false;
}

checkFn.value = async (manual) => {
  if (!qrState.value.imgUrl) loading();
  if (manual) checking.value = true;
  const oid = pid.value ? `${pid.value}_DM${orderId.value}` : orderId.value;
  const callApi = manual ? pullPaymentStatus : checkoutStatus;
  const res = await callApi({ orderId: oid });
  if (checking.value) checking.value = false;
  hide();
  if (!res.success || !res.data) return;
  const {
    paymentStatus,
    paymentFailureReason,
    orderDetail,
    expiredDate,
    checkout_url: checkoutURL,
    paymentMethod,
    qrContent,
  } = res.data;
  if (!number.value) {
    set(expiredDate);
    start();
  }
  if (number.value / 1000 !== expiredDate) {
    set(expiredDate);
  }
  if (
    expiredDate &&
    expiredDate < 240 &&
    !showTimeTip.value &&
    paymentStatus === PAY_STATUS.PENDING
  ) {
    showTimeTip.value = true;
    return showPayFailedDialog(app, 'PAY_TIME_TIP');
  }
  grandTotal.value = orderDetail.grandTotal;
  isIforteQris.value = paymentMethod === 'IFORTE_QRIS';
  qrState.value.imgUrl = isIforteQris.value ? qrContent : checkoutURL;
  pid.value = orderDetail?.payments?.[0]?.orderPaymentPreferenceId;
  payMethodTypeId.value = orderDetail?.payments?.[0]?.paymentMethodTypeId;
  if (paymentStatus === PAY_STATUS.PENDING) {
    if (manual) return showPayFailedDialog(app, PAY_STATUS.PENDING);
  }
  if (paymentStatus === PAY_STATUS.SUCCESS) {
    router.push({ name: 'success', query: { orderId: orderId.value } });
    return;
  }
  if (paymentStatus === PAY_STATUS.FAILED) {
    showPayFailedDialog(app, paymentFailureReason);
    pause();
  }
};

function onBack() {
  router.push({ name: 'products-list' });
}

onMounted(() => {
  checkFn.value();
});
</script>

<style scoped lang="scss">
.qris {
  background: #eee;
  position: relative;
  height: 100%;
  padding-top: 67px;
  overflow: auto;
}
.titleBox {
  display: flex;
  background: #ffffff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;
  .iconfont {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    padding: 10px 20px;
  }
  .title {
    font-weight: 800;
    font-size: 24px;
    color: #000000;
    margin: 0 24px;
  }
}

.countDown {
  color: #ff9e2d;
  margin-top: 26px;
  margin-bottom: 14px;
  text-align: center;
  .des {
    color: #000000;
  }
  .num {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
  .unit {
    font-size: 16px;
    line-height: 24px;
  }
}
.priceBox {
  color: #000000;
  text-align: center;
  font-weight: 700;
  margin-bottom: 16px;
  .pre {
    font-size: 16px;
  }
  .num {
    font-size: 36px;
  }
}
.qr {
  position: relative;
  width: 312px;
  margin: 0 auto;
  .qrCard {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .qrBox {
    width: 312px;
    display: inline-block;
    background-image: url('https://static.bakmigm.co.id/menu/payType/bg-QRIS2.png');
    background-size: contain;
    height: 439px;
    position: relative;
    .loading {
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%);
    }
    .qrimage {
      position: absolute;
      top: 140px;
      left: 33.5px;
      width: 245px;
      height: 245px;
      scale: 1.14;
    }
  }

  .topText {
    position: absolute;
    text-align: left;
    left: 108px;
    top: 19px;
    font-size: 12px;
    line-height: 14px;
    width: 155px;
    font-weight: 800;
  }
  .logoText {
    position: absolute;
    top: 66px;
    width: 100%;
    text-align: center;
    color: #000000;
    font-weight: 800;
    font-size: 16px;
    line-height: 120%;
  }
  .id {
    position: absolute;
    top: 93px;
    width: 100%;
    text-align: center;
    color: #000000;
    font-size: 12px;
    line-height: 120%;
  }
  .leftBottom {
    position: absolute;
    left: 3.5px;
    bottom: 10px;
    color: #000000;
    font-size: 12px;
    line-height: 120%;
    transform: scale(0.7);
  }
}
.moreBtnBox {
  position: fixed;
  left: 0;
  bottom: 24px;
  height: 32px;
  width: 100%;
  z-index: 1;
  text-align: center;
  .moreBtn {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    height: 32px;
    background: #fff;
    border: 2px solid #C63527;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
    border-radius: 23px;
    padding: 8px 16px;
    color: #C63527;
    font-weight: bold;
    .arrow {
      transform: rotate(-90deg);
      margin-left: 8px;
    }
  }
}
.scrollTopBtnBox {
  position: relative;
  height: 80px;
  text-align: center;
  z-index: 20;
  .scrollTopBtn {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    height: 32px;
    margin-top: 24px;
    border: 2px solid #C63527;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
    border-radius: 23px;
    padding: 8px 16px;
    color: #C63527;
    font-weight: bold;
    background: #fff;
    .arrow {
      transform: rotate(90deg);
      margin-left: 8px;
    }
  }
}

.btnBox {
  width: 320px;
  margin: 0 auto;
  margin-top: 16px;
  margin-bottom: 32px;
  .downBtn {
    background: #C63527;
    color: white;
    width: 320px;
    margin-top: 16px;
    margin-bottom: 16px;
    font-weight: bold;
    i {
      margin-right: 4px;
    }
  }
  .checkBtn {
    width: 320px;
    &.checking {
      pointer-events: none;
    }
  }
}
.howUseBox {
  .howUseTitle {
    padding: 0 16px;
    font-size: 14px;
    line-height: 18px;
    color: #000000;
    margin-bottom: 16px;
    font-weight: bold;
  }
  .stepBox {
    padding: 0 11px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    .stepTitleBox {
      display: flex;
      .numberIcon {
        width: 20px;
        height: 20px;
        background: #ff9e2d;
        border-radius: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 12px;
        font-weight: bold;
        flex-shrink: 0;
        margin-right: 4px;
      }
      span {
        text-align: left;
      }
    }

    img {
      width: 94px;
      height: 100px;
      border-radius: 16px;
    }
  }
  .item {
    padding: 0 5px;
  }
}
.payfrom {
  background: #fff;
  h4 {
    color: #111827;
    font-size: 14px;
    line-height: 18px;
    font-weight: bold;
    padding: 16px;
    margin-bottom: 0;
  }
  padding-bottom: 10px;
}
.payDialog {
  background: #fff;
  .dialogTitle {
    height: 48px;
    display: flex;
    font-weight: bold;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 20px;
    font-size: 14px;
  }
  .stepBox {
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    padding-bottom: 20px;
    .bold {
      font-weight: bold;
    }
    .stepTitleBox {
      display: flex;
      font-size: 12px;
      padding-top: 8px;
      width: 100px;
      .numberIcon {
        width: 20px;
        height: 20px;
        background: #ff9e2d;
        border-radius: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 12px;
        font-weight: bold;
        flex-shrink: 0;
        margin-right: 4px;
      }
      span {
        text-align: left;
      }
    }
    img {
      width: 100px;
      height: 200px;
      border-radius: 5px;
      margin-top: 8px;
    }
  }
}
.payfromItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  .payfromItemLeftBox {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 16px;
    span {
      margin-left: 6px;
      font-weight: bold;
      color: #1d1819;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
.blackSolid {
  border: 0.5px solid #d1d5db;
  margin-left: 16px;
  margin-top: 12px;
  margin-bottom: 16px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
